<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" color="white">
          <v-icon small class="pr-4">mdi-menu-down</v-icon>
          Lägg till
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          @click="item.action"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog :value="showCreateManually" width="600" persistent>
      <CrewCreateModal
        v-if="showCreateManually"
        @close="showCreateManually = false"
      />
    </v-dialog>

    <v-dialog :value="showDelayFromThrModal" width="600" persistent>
      <CrewCreateThrModal
        v-if="showDelayFromThrModal"
        @close="showDelayFromThrModal = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import CrewCreateModal from './CrewCreateModal'
import CrewCreateThrModal from './CrewCreateThrModal'

export default {
  name: 'CrewCreateDropdown',

  components: {
    CrewCreateModal,
    CrewCreateThrModal
  },

  data: () => ({
    showCreateManually: false,
    showDelayFromThrModal: false
  }),

  computed: {
    items() {
      return [
        {
          title: 'Manuellt',
          action: () => {
            this.showCreateManually = true
          }
        },
        {
          title: 'Från THR',
          action: () => {
            this.showDelayFromThrModal = true
          }
        }
      ]
    }
  }
}
</script>
